var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-avatar",on:{"click":_vm.goCharacterDetail}},[_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }